import "./Spacer.css";

export function Spacer() {
  return <div className="mkt-spacer" />;
}
